import React from 'react';
import apiHelper from '../../../utils/apiHelpers';
import AsyncSelect from 'react-select/async';
import { useEffect, useState } from 'react';
import { colors } from '../../../theme';
const SelectBrand = props => {
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(null);
  const color = 'black';
  const colorBg = 'white';
  const colorHover = colors.primary['50'];
  const colorHoverOption = colors.primary['200'];

  useEffect(() => {
    let { value } = props;
    let userValue;
    if (value.length && value.length > 0) {
      userValue = options.find(
        option => String(option.value) === String(value),
      );

      userValue ? setValue(userValue) : loadDefaultOptions(value);
    } else {
      setValue([]);
    }
  }, [props.value]);

  useEffect(() => {
    defaultOptions();
  }, []);

  const handleChange = (selectedValue, type) => {
    //type.action : clear,select-option,remove-value,
    if (
      type.action == 'clear' ||
      type.action == 'remove-value' ||
      type.action == 'select-option'
    ) {
      defaultOptions();
    }
    let event = { target: {} };
    event.target.name = props.name ? props.name : 'select-options-nameless';
    event.target.value = selectedValue ? selectedValue.map(r => r.value) : [];
    event.target.type = 'react-select';
    props.onChange(event);
  };

  const defaultOptions = async () => {
    let filters = {
      where: {
        productBrand: '',
      },
    };

    apiHelper
      .getProductBrand(filters)
      .then(response => {
        let entitiesForSelect = response.data.map(entity => {
          return {
            value: entity.productBrand,
            label: entity.productBrand,
          };
        });

        setOptions(entitiesForSelect);
      })
      .catch(e => {
        console.log(e);
      });
  };

  const loadOptions = (input, callback) => {
    if (!input.length) return;

    let filters = {
      where: {
        productBrand: input,
      },
    };

    apiHelper
      .getProductBrand(filters)
      .then(response => {
        let entitiesForSelect = response.data.map(entity => {
          return {
            value: entity.productBrand,
            label: entity.productBrand,
          };
        });

        setOptions(entitiesForSelect);
        callback(entitiesForSelect);
      })
      .catch(e => {
        console.log(e);
      });
  };

  const loadDefaultOptions = value => {
    if (!value) return;

    let filters = {
      where: {
        productBrand: value,
      },
    };

    apiHelper
      .getProductBrand(filters)
      .then(response => {
        let entitiesForSelect = response.data.map(entity => {
          return {
            value: entity.productBrand,
            label: entity.productBrand,
          };
        });

        setOptions(
          entitiesForSelect.length
            ? entitiesForSelect.filter(
                entity => entity !== entitiesForSelect[0],
              )
            : entitiesForSelect,
        );
        setValue(entitiesForSelect[0]);
      })
      .catch(e => {
        console.log(e);
      });
  };

  const customStyles = {
    control: provided => ({
      ...provided,
      border: '0px solid black',
      backgroundColor: 'none',
      outline: 'none',
      '&:hover': { backgroundColor: colorHover },
    }),
    placeholder: () => ({
      color: color,
      fontSize: '16px',
      marginLeft: '8px',
      '&:hover': { fontSize: '15px' },
    }),

    singleValue: () => ({
      color: color,
    }),

    menuList: provide => ({
      ...provide,
      color: color,
      backgroundColor: colorBg,
    }),
    option: (provider, state) => ({
      ...provider,
      '&:hover': { backgroundColor: colorHoverOption },
      backgroundColor: state.isFocused ? colorHoverOption : 'none',
      color: color,
    }),
  };

  let components = props.isDisabled && {
    DropdownIndicator: () => null,
    IndicatorSeparator: () => null,
  };

  return (
    <AsyncSelect
      cacheOptions={true}
      styles={customStyles}
      onChange={handleChange}
      defaultOptions={options}
      loadOptions={loadOptions}
      value={value}
      name={props.name}
      required={props.required}
      components={components}
      isDisabled={props.isDisabled}
      isMulti={true}
      placeholder={props.placeholder ? props.placeholder : 'Marca'}
    />
  );
};

export default SelectBrand;
